import { render } from "./ProspectToPipelineModal.vue?vue&type=template&id=87500a9e&scoped=true"
import script from "./ProspectToPipelineModal.vue?vue&type=script&lang=js"
export * from "./ProspectToPipelineModal.vue?vue&type=script&lang=js"

import "./ProspectToPipelineModal.vue?vue&type=style&index=0&id=87500a9e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87500a9e"]])

export default __exports__